import {
  ArrowDown,
  ArrowDownZA,
  ArrowUp,
  ArrowUpAZ,
  ArrowUpDown,
  CalendarArrowDown,
  CalendarArrowUp,
} from "lucide-react";

export const SortableHeader = ({
  text,
  direction,
  onClick,
  iconType,
}: {
  text: string;
  direction: "asc" | "desc" | false;
  onClick?: (event: unknown) => void;
  iconType?: "alpha" | "date";
}) => {
  const UpIcon =
    iconType === "alpha"
      ? ArrowUpAZ
      : iconType === "date"
        ? CalendarArrowUp
        : ArrowUp;
  const DownIcon =
    iconType === "alpha"
      ? ArrowDownZA
      : iconType === "date"
        ? CalendarArrowDown
        : ArrowDown;
  return (
    <div onClick={onClick} className="cursor-pointer flex items-center gap-1">
      {text}
      {direction === "asc" ? (
        <UpIcon className="ml-2 h-4 w-4" />
      ) : direction === "desc" ? (
        <DownIcon className="ml-2 h-4 w-4" />
      ) : (
        <ArrowUpDown className="ml-2 h-4 w-4 text-gray-500" />
      )}
    </div>
  );
};
